import * as React from "react"
import { useForm, FormProvider } from "react-hook-form"
import { Box, Button, InputAdornment } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import { TextInput, NullableBooleanInput, useListContext, SelectInput, ReferenceInput, AutocompleteInput, DateInput } from "react-admin"
import { useEffect } from "react"

const OrderFilterForm = () => {
  const {
    displayedFilters,
    filterValues,
    setFilters,
    hideFilter
  } = useListContext()

  const form = useForm({
    defaultValues: {
      ...filterValues,
      q: filterValues.q || ''
    }
  });

  useEffect(() => {
    if (!displayedFilters.main) {
      form.reset();
    }
  }, [displayedFilters.main, form]);

  if (!displayedFilters.main) return null

  const onSubmit = values => {
    if (Object.keys(values).length > 0) {
      setFilters(values)
    } else {
      hideFilter("main")
    }
  }

  const resetFilter = () => {
    form.reset()
    setFilters({}, [])
  }

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Box display="flex" alignItems="flex-end" mb={1}>
          <Box component="span" mr={2}>
            <TextInput
              resettable
              helperText={false}
              source="q"
              label="搜尋"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon color="disabled" />
                  </InputAdornment>
                )
              }}
            />
          </Box>
          <Box component="span" mr={2}>
            <DateInput
              source="beginCreatedAt"
              label="建立日期(起)"
              helperText={false}
            />
          </Box>
          <Box component="span" mr={2}>
            <DateInput
              source="endCreatedAt"
              label="建立日期(迄)"
              helperText={false}
            />
          </Box>
          <Box component="span" mr={2}>
            <SelectInput
              resettable
              source="status"
              label="訂單狀態"
              emptyText="全部"
              helperText={false}
              choices={[
                { id: 'pending_payment', name: '待付款' },
                { id: 'pending_approval', name: '處理中' },
                { id: 'pending_receipt', name: '已出貨' },
                { id: 'completed', name: '已完成' },
                { id: 'canceled', name: '已取消' },
              ]}
            />
          </Box>
          <Box component="span" mr={2} mb={1.5}>
            <Button variant="outlined" color="primary" type="submit">
              篩選
            </Button>
          </Box>
          <Box component="span" mb={1.5}>
            <Button variant="outlined" onClick={resetFilter}>
              關閉
            </Button>
          </Box>
        </Box>
      </form>
    </FormProvider>
  )
}

export default OrderFilterForm;